import { NumberUtils } from '@pk/powerkioskutils';
import moment from 'moment-timezone';
import { HelperService } from '../helper.service';

export class ReportContractStatus {
	public contractId: string;
	public contractNum: string;
	public status: number;
	public displayStatus: string;
	public contractDate: Date;
	public confirmationDate: Date;
	public effectiveDate: Date;
	public expirationDate: Date;
	public addDate: Date;
	public term: number;
	public margin: number;
	public units: string;
	public annualUsage: number | string;
	public rate: number;
	public rejectReason: string;
	public externalId: string;
	public ipAddress: string;
	public signIPAddress: string;
	public agentIPAddress: string;
	public customerId: string;
	public dbaName: string;
	public phone: string;
	public email: string;
	public customerAddress1: string;
	public customerAddress2: string;
	public customerCity: string;
	public customerZipCode: string;
	public customerStateShort: string;
	public stateId: string;
	public stateShort: string;
	public agentId: string;
	public agentName: string;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public contractLocationId: string;
	public utilityAccountNum: string;
	public supplierId: string;
	public supplierName: string;
	public promoCode: string;
	public utilityName: string;
	public hasHappyCustomer: boolean;
	public hasLVM: boolean;
	public hasIssueFound: boolean;
	public rejectReasonCategoryName: string;
	public commissionSplitBufferMarginParent: number;
	public commissionSplitBufferMarginBrother: number;
	public bufferMargin: number;
	public isResidential: boolean;
	public commissionPayPlanName: string;
	public locationCount: number;
	public matrixAgentBufferMargin: number;
	public isoCode: string;
	public smartEnrollOptionName: string;
	public pkMargin: number;

	constructor(reportContractStatus: ReportContractStatus) {
		Object.assign(this, reportContractStatus);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY hh:mm:ss a')) : this.effectiveDate;
		this.contractDate = this.contractDate ? new Date(moment(this.contractDate).format('MMM DD, YYYY hh:mm:ss a')) : this.contractDate;
		this.confirmationDate = this.confirmationDate ? new Date(moment(this.confirmationDate).format('MMM DD, YYYY hh:mm:ss a')) : this.confirmationDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY hh:mm:ss a')) : this.expirationDate;
		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY hh:mm:ss a')) : this.addDate;
		this.annualUsage = this.isResidential ? 'Residential' : this.annualUsage;
	}

	get fullAddressLine(): string {
		return (
			`${this.customerAddress1} ${this.customerAddress2 ? this.customerAddress2 + ' ' : ''}` +
			`${this.customerCity}, ${this.customerStateShort} ${this.customerZipCode}`
		);
	}

	get signatureDate(): Date {
		return [0, 2].includes(this.status) ? this.contractDate : null;
	}

	public getTotalMargin(): number {
		return HelperService.getTotalMargin(this, false, false, false, this.units);
	}

	public getCommissionSplitBufferMarginParent(): number {
		return HelperService.getCommissionSplitBufferMarginParent(this, this.units);
	}

	public getCommissionSplitBufferMarginBrother(): number {
		return HelperService.getCommissionSplitBufferMarginBrother(this, this.units);
	}

	public getDisplayAnnualUsage(): string {
		const annualUsage = NumberUtils.amountToUnits(this.annualUsage, this.units);

		return Math.round(annualUsage).toString();
	}
}
